// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Identities extends APIResource {
    /**
     * Attach an identity to an agent.
     */
    attach(identityID, params, options) {
        const { agent_id } = params;
        return this._client.patch(path `/v1/agents/${agent_id}/identities/attach/${identityID}`, options);
    }
    /**
     * Detach an identity from an agent.
     */
    detach(identityID, params, options) {
        const { agent_id } = params;
        return this._client.patch(path `/v1/agents/${agent_id}/identities/detach/${identityID}`, options);
    }
}
//# sourceMappingURL=identities.mjs.map